const styles = theme => ({
  numberInputContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  numberInputLabel: {
    flex: 1,
    fontSize: '14px',
    fontWeight: 500,
  },
  numberInput: {
    width: '120px',
    '& .MuiInputBase-root': {
      height: '40px',
    },
  },
  inputButton: {
    cursor: 'pointer',
    padding: theme.spacing(0, 1),
    userSelect: 'none',
  },
})

export default styles
